import { Choice } from '90.quickConnect.Models/models';
import { isChoice } from '90.quickConnect.Models/guards';

export default function isChoiceList(input: unknown): input is Choice[] {
  return Array.isArray(input) && input.every(isChoice);
}
